import React, { useState, useEffect } from "react";
// import gallery from "../assets/gallery.jpg";
// import gall from "../assets/gall.JPG";
import { MdArrowForwardIos } from "react-icons/md";
import { FiSearch } from "react-icons/fi";
import { IoMdClose } from "react-icons/io";
import { FaVideo } from "react-icons/fa";
// import eve from "../assets/eve.JPG"
// import even from "../assets/even.JPG"
import event from "../assets/event.JPG"
import pic3 from "../assets/pic3.jpg";
import pic4 from "../assets/pic4.jpg";
// import pic5 from "../assets/pic5.jpg";
import pic6 from "../assets/pic6.jpg";
// import pic7 from "../assets/pic7.jpg";
import pic8 from "../assets/pic8.JPG";
import pic9 from "../assets/pic9.jpeg";
import pic10 from "../assets/pic10.jpeg";
import pic11 from "../assets/pic11.JPG";
import pic12 from "../assets/pic12.JPG";
import pic13 from "../assets/pic13.JPG";
import pic14 from "../assets/pic14.jpeg";
import pic16 from "../assets/pic16.JPG";
import pic17 from "../assets/pic17.JPEG";
import pi1 from "../assets/pi1.jpeg";
import pi2 from "../assets/pi2.JPG";
import pi4 from "../assets/pi4.jpeg";
import pi5 from "../assets/pi5.jpg";
import pi6 from "../assets/pi6.jpeg";
import uktour1 from "../assets/uktour1.png";
import uktour2 from "../assets/uktour2.jpeg";
import uktour3 from "../assets/uktour3.png";
import uktour4 from "../assets/uktour4.png";
import uktour5 from "../assets/uktour5.jpeg";
import uktour6 from "../assets/uktour6.jpeg";

import video1 from "../assets/video1.mp4";
import video2 from "../assets/video2.mp4";
import video3 from "../assets/video3.mp4";
import video4 from "../assets/video4.mp4";
import nohmi15 from "../assets/nohmi15june.jpeg";

import Footer from "./Footer";
import Navigation from "./Navigation";
import { Link } from "react-router-dom";

const Events = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);

  useEffect(() => {
    setIsVisible(true);
    window.scrollTo(0, 0);
  }, []);

  const openModal = (media) => setSelectedImage(media);
  const closeModal = () => setSelectedImage(null);

  const allMedia = [
    nohmi15, uktour4, uktour3, uktour1,
    uktour2, uktour5, uktour6,
    pi1, pic9, pic10,
    pi6, pi4, pi5,
    pic12, pic13, pic11,
    video1, pic4, pic6,
    pic17, video2, pic14,
    pi2, pic3, video3,
    pic8, video4, pic16,
  ];

  const groupMedia = (arr) => {
    const res = [];
    for (let i = 0; i < arr.length; i += 3) {
      res.push(arr.slice(i, i + 3));
    }
    return res;
  };

  const mediaGroups = groupMedia(allMedia);

  // Function to get custom height for specific images
  const getCustomHeight = (item) => {
    // Check if the item matches any of the specific images
    if (item === nohmi15) {
      return "h-[280px]"; 
    }
    if (item === uktour4) {
      return "h-[280px]"; 
    }
    if (item === uktour3) {
      return "h-[280px]"; 
    }
    // Default height for all other images
    return "h-[220px]";
  };

  return (
    <>
      <div className="sticky top-0 z-50 bg-white shadow-md w-full">
        <Navigation />
      </div>

      <div className="relative h-[210px] overflow-hidden">
        <img
          src={event}
          alt="Events"
          className="w-full h-auto object-cover"
        />
        <div className="absolute inset-0 bg-black/50"></div>

        <div className="absolute inset-0 flex items-center px-4 xl:px-20">
          <h1
            className={`uppercase text-xl md:text-2xl lg:text-5xl text-white transition-all duration-700 
              ${isVisible
                ? "translate-x-0 opacity-100"
                : "-translate-x-10 opacity-0"
              }`}
          >
            Gallery
          </h1>
        </div>
      </div>

      <div className="w-full px-4 xl:px-20 py-5 xl:py-6">
        <div
          className={`flex flex-wrap items-center gap-2 text-md md:text-lg transform transition-all duration-700 ${isVisible ? "translate-y-0 opacity-100" : "translate-y-5 opacity-0"
            }`}
        >
          <Link
            to="/"
            className="uppercase text-green-700 hover:underline transition-colors duration-300"
          >
            Home
          </Link>
          <MdArrowForwardIos className="text-gray-600 text-xs mt-0.5" />
          <p className="uppercase text-md md:text-lg text-gray-800">Gallery</p>
        </div>
      </div>

      <div className="px-4 xl:px-20 py-8">
        <h2 className="text-2xl md:text-4xl font-semibold uppercase text-gray-800 mb-3">
          Our Events Gallery
        </h2>
        <p className="text-gray-600 mb-8 text-md md:text-lg">
          Discover our memorable moments and gatherings
        </p>

        {mediaGroups.map((group, i) => (
          <div key={i} className="mb-16">
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
              {group.map((item, idx) => {
                const isVideo =
                  typeof item === "string" && item.endsWith(".mp4");
                
                // Get the custom height for this item
                const heightClass = getCustomHeight(item);

                return (
                  <div
                    key={idx}
                    className="group cursor-pointer hover:-translate-y-2 transition duration-500"
                    onClick={() => openModal(item)}
                  >
                    <div className="relative rounded-xl shadow-xl shadow-gray-950">
                      <div className={`overflow-hidden rounded-xl relative ${heightClass}`}>

                        {isVideo && (
                          <div className="absolute top-3 right-3 bg-black/70 text-white p-2 rounded-full z-20">
                            <FaVideo className="text-lg" />
                          </div>
                        )}

                        {!isVideo && (
                          <img
                            src={item}
                            alt="Event"
                            className={`w-full ${heightClass} object-cover transition duration-700 group-hover:scale-110`}
                          />
                        )}

                        {isVideo && (
                          <video 
                            src={item}
                            muted
                            playsInline
                            preload="metadata"
                            className={`w-full ${heightClass} object-cover transition duration-700 group-hover:scale-110`}
                          />
                        )}

                        <div className="absolute inset-0 bg-black/30 opacity-0 group-hover:opacity-50 transition"></div>

                        <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition">
                          <div className="bg-white w-12 h-12 flex items-center justify-center rounded-full shadow-lg border border-gray-200 group-hover:scale-110 transition">
                            {!isVideo && (
                              <FiSearch className="text-2xl text-gray-700" />
                            )}
                            {isVideo && (
                              <FaVideo className="text-2xl text-gray-700" />
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        ))}
      </div>

      {selectedImage && (
        <div
          className="fixed inset-0 bg-black/90 z-[999] flex items-center justify-center p-4"
          onClick={closeModal}
        >
          <button
            onClick={closeModal}
            className="absolute top-6 right-6 z-[1000] bg-black/70 p-2 rounded-full hover:bg-black transition"
          >
            <IoMdClose className="text-white text-2xl" />
          </button>

          {typeof selectedImage === "string" &&
            selectedImage.endsWith(".mp4") ? (
            <video
              src={selectedImage}
              autoPlay
              controls
              className="max-w-full max-h-[80vh] object-contain rounded-lg shadow-lg"
            ></video>
          ) : (
            <img
              src={selectedImage}
              alt="Nohmi Bosai"
              className="max-w-full max-h-[80vh] object-contain rounded-lg shadow-lg"
            />
          )}
        </div>
      )}

      <Footer />
    </>
  );
};

export default Events;